import { render } from "./ModalUseKit.vue?vue&type=template&id=f5218d18"
import script from "./ModalUseKit.vue?vue&type=script&lang=js"
export * from "./ModalUseKit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/modals/ModalUseKit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5218d18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5218d18', __exports__)) {
    api.reload('f5218d18', __exports__)
  }
  
  module.hot.accept("./ModalUseKit.vue?vue&type=template&id=f5218d18", () => {
    api.rerender('f5218d18', render)
  })

}


export default __exports__